// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/faqIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="FAQ" aria-label="FAQ" />;
}
